export default function _eventBuilder() {
    /**
     * event-builder element
     * @const {string}
     */
    const EVENT_BUILDER_SELECTOR = '.event-builder';
    /**
     * 'open to the public' radio buttons
     * @const {string}
     */
    const RADIO_BUTTONS_SELECTOR = 'open-public';
    /**
     * select field for audience types
     * @const {string}
     */
    const AUDIENCE_SELECT_FIELD = '.audience-list';
    /**
     * audience type option elements
     * @const {string}
     */
    const OPTION_ELEMENTS = 'option';

    const initialiseEventBuilder = () => {
        const publicRadioButtons = document.getElementsByName(
            RADIO_BUTTONS_SELECTOR
        );
        // const audienceSelect = document.querySelector('.audience-list').children.find((child) => child.tagName === 'SELECT')
        const audienceSelect = document.querySelector(
            AUDIENCE_SELECT_FIELD
        ).children;
        const audienceOptions = Array.from(
            audienceSelect[audienceSelect.length - 1].getElementsByTagName(
                OPTION_ELEMENTS
            )
        );
        // extract public option
        const publicOption = audienceOptions.find(
            (option) => option.value === 'Public'
        );
        // extract all options excluding public
        const remainingOptions = audienceOptions.filter(
            (option) => option.value !== 'Public'
        );

        // iterate radio buttons
        publicRadioButtons.forEach((button) => {
            // apply change event
            button.addEventListener('change', () => {
                // if yes – leave only public and select it
                if (button.value === 'Yes' && button.checked === true) {
                    publicOption.setAttribute('selected', 'selected');
                    publicOption.removeAttribute('style');
                    remainingOptions.forEach((option) => {
                        option.setAttribute('style', 'display: none');
                        option.removeAttribute('selected', 'selected');
                    });
                    // if no – remove public
                } else {
                    publicOption.removeAttribute('selected', 'selected');
                    remainingOptions.forEach((option) =>
                        option.removeAttribute('style')
                    );
                    publicOption.setAttribute('style', 'display: none');
                }
            });
        });
    };

    /**
     * @const {boolean}
     */
    const eventBuilder = !!document.querySelector(EVENT_BUILDER_SELECTOR);

    // If the module exists, do whatever we need to
    if (eventBuilder) {
        initialiseEventBuilder();
    }
}

// calls the carousel function
_eventBuilder();
